import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/CommissionBatch/List',
    method: 'post',
    data,
  })
}

export function getItem(param) {
  let data = param
  if (typeof data === 'number') {
    data = { id: param }
  }
  console.log('data', data)

  return request({
    url: '/CommissionBatch/Get',
    method: 'post',
    data,
  })
}

export function createItem(data) {
  return request({
    url: '/CommissionBatch/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  return request({
    url: '/CommissionBatch/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/CommissionBatch/Delete',
    method: 'delete',
    data,
  })
}
